import { format } from 'date-fns';

const MessageBubble = ({ message, isOwn }) => {
  const formatTime = (date) => {
    if (!date) return '';
    
    try {
      return format(new Date(date), 'h:mm a');
    } catch (error) {
      return '';
    }
  };

  const getStatusDisplay = (status) => {
    switch (status) {
      case 'read':
        return 'Read';
      case 'delivered':
        return 'Delivered';
      case 'sent':
      default:
        return 'Sent';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'read':
        return 'text-green-600';
      case 'delivered':
        return 'text-blue-600';
      case 'sent':
      default:
        return 'text-gray-500';
    }
  };

  return (
    <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'}`}>
      <div className={`max-w-[70%] lg:max-w-[60%] ${
        isOwn ? 'order-2' : 'order-1'
      }`}>
        <div className={`
          px-4 py-3 rounded-2xl shadow-sm
          ${
            isOwn
              ? 'bg-gradient-to-br from-blue-600 to-blue-700 text-white rounded-br-sm' :'bg-card border border-border text-foreground rounded-bl-sm'
          }
        `}>
          <p className="text-sm leading-relaxed whitespace-pre-wrap break-words">
            {message?.content}
          </p>
        </div>
        <div className={`flex items-center gap-1 mt-1 px-1 ${
          isOwn ? 'justify-end' : 'justify-start'
        }`}>
          <span className="text-xs text-muted-foreground">
            {formatTime(message?.createdAt)}
          </span>
          {isOwn && (
            <span className={`text-xs font-medium ${getStatusColor(message?.status)}`}>
              • {getStatusDisplay(message?.status)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;